import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { history } from "../../services/history";
import { readSession } from "../session/sessionActions";
import { loginDone, loginFailed } from "./loginAction";
import { LoginActionTypes } from "./loginTypes";
import dataService from "../../services/dataService";
import { showNotification } from "../notification/notificationActions";

export const submitLoginEpic = (action$: any, state$: any): any => {
  return action$.pipe(
    ofType(LoginActionTypes.SUBMIT_LOGIN),
    switchMap((action: any): any => {
      return dataService.authToken(action.token).pipe(
        map((res: any) => {}),
        catchError((error) =>
          of(
            loginFailed(error),
            showNotification("login.failedLoginErrorLabel", "error", "")
          )
        )
      );
    })
  );
};

export const loginSuccessEpic = (action$: any, state$: any): any => {
  return action$.pipe(
    ofType(LoginActionTypes.LOGIN_SUCCESS),
    switchMap((action: any): any => {
      history.push("badges");
      return of(readSession(), loginDone());
    })
  );
};

export const signupSuccessEpic = (action$: any, state$: any): any => {
  return action$.pipe(
    ofType(LoginActionTypes.QR_SIGNUP_SUCCESS),
    switchMap((action: any): any => {
      history.push("badges");
      return of(readSession());
    })
  );
};

export const loginOutEpic: any = (action$: any) => {
  return action$.pipe(
    ofType(LoginActionTypes.LOGOUT),
    switchMap((action: any): any => {
      sessionStorage.clear();
      return of(loginDone());
    })
  );
};
